import React from 'react';
import { Link } from 'react-router-dom';

const FEATURES = [
  {
    label: 'INSTANT TRIGGER',
    icon: '☝️',
    title: 'One-Tap Emergency SOS',
    body: "When safety is compromised, you don't have time to type messages, navigate contact lists, or explain your location. A single tap on the large red RAKSHA SOS button initiates a complete safety broadcast.",
    bullets: [
      { icon: 'bi-crosshair', title: 'Automatic GPS Capture', sub: "Your phone's hardware GPS is queried immediately to lock your precise coordinates within 3 metres." },
      { icon: 'bi-lightning-fill', title: 'Zero Delay Action', sub: 'No verification codes, confirmation dialogues, or delays. One tap commits the alert to the local network.' },
    ],
  },
  {
    label: 'TRUST & SECURITY',
    icon: '🪪',
    title: 'Identity-Verified Network',
    body: 'We believe a safety app is only as safe as the people using it. Unlike other apps that allow anonymous sign-ups, RAKSHA Ireland enforces a zero-tolerance policy against anonymous profiles.',
    bullets: [
      { icon: 'bi-card-image', title: 'Government Photo ID Required', sub: "Every user must submit a photograph of an official document (passport, driver's licence, or age card) to register." },
      { icon: 'bi-person-check-fill', title: 'Manual Administrative Verification', sub: 'No algorithmic approximations. A live RAKSHA team member manually checks each document to approve access.' },
    ],
  },

  {
    label: 'PSYCHOLOGICAL ASSURANCE',
    icon: '🚑',
    title: 'Help is on the Way!',
    body: "During extreme stress, waiting in silence is agonising. RAKSHA's live acceptance workflow connects you with responders instantly so you know help is moving.",
    bullets: [
      { icon: 'bi-activity', title: 'Real-Time Confirmation', sub: "The split-second a nearby volunteer swipes 'I\'m on my way', your phone screen updates with their profile card and ETA." },
      { icon: 'bi-chat-heart-fill', title: 'Active Safety Feedback', sub: 'Prompts to keep you calm, urging you to stay in well-lit areas or lock your doors while help approaches.' },
    ],
  },
  {
    label: 'AUDITABILITY',
    icon: '📋',
    title: 'Full Alert History Logs',
    body: 'To maintain accountability and assist law enforcement when necessary, every emergency alert, response detail, and resolution is permanently stored in your encrypted safety vault.',
    bullets: [
      { icon: 'bi-journal-text', title: 'Full Resolution Logging', sub: 'See details of previous alerts you triggered, who accepted them, arrival time, and how the emergency was resolved.' },
      { icon: 'bi-lock-fill', title: 'Encrypted Archives', sub: 'Log history is strictly archived with end-to-end security so only you and authorised investigators have access.' },
    ],
  },

];

export default function Features() {
  return (
    <main>
      {/* Page Hero */}
      <div className="page-hero">
        <div className="rk-container">
          <span className="page-hero-label">Deep Dive</span>
          <h1 className="page-hero-title">Built For Real Emergencies</h1>
          <p className="page-hero-sub">
            Explore the technology, identity verification, and local response systems behind RAKSHA Ireland.
          </p>
        </div>
      </div>

      {/* Feature Sections */}
      <div style={{ background: 'var(--rk-white)' }}>
        {FEATURES.map((f, i) => (
          <div className="feat-detail-section" key={f.title}>
            <div className="rk-container">
              <div className={`feat-detail-grid${i % 2 !== 0 ? ' reverse' : ''}`}>
                {/* Text */}
                <div>
                  <p className="feat-detail-label">{f.label}</p>
                  <h2 className="feat-detail-title">{f.title}</h2>
                  <p className="feat-detail-body">{f.body}</p>
                  <div className="feat-bullets">
                    {f.bullets.map(b => (
                      <div className="feat-bullet" key={b.title}>
                        <div className="feat-bullet-icon"><i className={`bi ${b.icon}`}></i></div>
                        <div>
                          <div className="feat-bullet-title">{b.title}</div>
                          <div className="feat-bullet-sub">{b.sub}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Illustration */}
                <div className="feat-illustration">
                  <span style={{ fontSize: '5rem' }}>{f.icon}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div style={{ background: 'var(--rk-bg)', padding: '72px 0', textAlign: 'center' }}>
        <div className="rk-container">
          <h2 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: 12 }}>Ready to experience true safety?</h2>
          <p style={{ color: 'var(--rk-muted)', marginBottom: 32 }}>Become part of the community safety grid in Ireland today.</p>
          <a href="#download" className="hero-btn-primary" style={{ display: 'inline-flex' }}>
            <i className="bi bi-google-play"></i>
            Join RAKSHA Ireland
          </a>
        </div>
      </div>
    </main>
  );
}
